import { Button, notification, Tooltip } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import React, { useState } from "react";
import { useContractLoader, useBalance } from "../hooks";
import { Transactor } from "../helpers";
import { formatEther, parseEther, formatUnits } from "@ethersproject/units";
import { DEFAULT_CONTRACT_NAME, MAX_MINTABLE_NFT } from "../constants";
import { tryToDisplay, tryToDisplayAsText } from "./Contract/utils";

const DEBUG = false;

async function mintNFT({contract, ownerAddress, provider, gasPrice, setStatus}, mintprice, presaleflag, qty) {

  // scaffold-eth's Transactor helper gives us a nice UI popup when a transaction is sent
  const transactor = Transactor(provider, gasPrice);
  let tx;
  console.log("presaleFlag", presaleflag);
  console.log("price", tryToDisplay(mintprice));
  // Trigger the minting and add payment to it.
  if (presaleflag) {
      // PreSale
      tx = await transactor(contract.mintWhitelist(qty));
  }
  else {
      // Regular public sale
      tx = await transactor(contract.mint(1, { value: mintprice}));
  }

  setStatus("Blockchain transaction sent, waiting confirmation...");

  // Wait for the transaction to be confirmed, then get the token ID out of the emitted Transfer event.
  try {
    const receipt = await tx.wait();
    if (!receipt) {
        setStatus(`The transaction was rejected`);
        return 0;
    }

    let listTokenId = [];
    for (const event of receipt.events) {
        if (event.event !== 'Transfer') {
            continue
        }
        else {
          listTokenId.push(event.args.tokenId.toString());
          if (listTokenId.length == qty) {
            break;  
          }
        }
    }
    setStatus(`NFT #${listTokenId} minted`);
    return listTokenId;
  } catch (e) {
        console.log(e);
        notification.error({
            message: "Transaction Rejected",
            description: e.message,
        });
        setStatus("Transaction rejected");
  }
}

export default function CollectionMintButton({
  contract,
  account,
  gasPrice,
  signer,
  provider,
  name,
  blockExplorer,
  totalSupply,
  price,
  balance,
  whiteListEnabled,
  freeMintOpened,
  publicSaleEnabled,
}) {

  const address = contract ? contract.address : "";

  const [minting, setMinting] = useState(false);
  const [mintingPreSale, setMintingPreSale] = useState(false);
  const [status, setStatus] = useState("");
  const [tokenId, setTokenId] = useState(null);

  if (DEBUG) console.log("signer balance", tryToDisplayAsText(balance));
  if (DEBUG) console.log("minting cost", tryToDisplayAsText(price));

  // Test if enough NFTs remaining to mint
  const mintRemaining = totalSupply ? (MAX_MINTABLE_NFT - totalSupply.toNumber()) > 0 : false;
  const badConnection = totalSupply ? false : true;
  const mintEnabled = (balance && price && freeMintOpened) ? balance.gt(price) : false; // add some test for a connected wallet and or switch between the 2 buttons
  const mintPresaleEnabled = freeMintOpened;
  
  const mintedSoFarText = (
    <p className="mint-sofar">
        {tryToDisplay(totalSupply)} / {MAX_MINTABLE_NFT} Moon Master NFTs minted
    </p>
  );

  const badConnectionText = (
    <p className="mint-sofar">
        Connect to Fantom Opera Chain or Refresh Wallet
    </p>
  );

  const mintYourOwnText = (
    <p className="mint-yourown">
        Mint your own NFT for {tryToDisplayAsText(price)} FTM. {mintEnabled ? "" : "Get more FTMs"}
    </p>
  );

  // Update the URLs of the collection on the marketplace
  const outOfNFTs = (
    <p className="mint-outofnft">
        Sold out! Find us on <a href="_blank" target="_blank">NFTKEY</a>.
    </p>
  );

  const priceDisplayed = price ? tryToDisplayAsText(price.mul(1)) : "0";
  const whiteListDisplayed = whiteListEnabled ? "MINT " + whiteListEnabled + " FOR FREE" : "NO FREE MINT";

  const startMinting = () => {
    if (DEBUG) console.log(`minting nft ${tryToDisplay(totalSupply)}`);
    setMinting(true);
    signer.getAddress().then(ownerAddress => {
      mintNFT({ 
        contract, 
        provider, 
        ownerAddress, 
        gasPrice, 
        setStatus
      },
        price,
        false,
        1,
      ).then(newTokenId => {
        setMinting(false);
        console.log('minting complete');
        setTokenId(newTokenId);
      })
    });
  }

  const startPresaleMinting = () => {
    setMintingPreSale(true);
    signer.getAddress().then(ownerAddress => {
      mintNFT({ 
        contract, 
        provider, 
        ownerAddress, 
        gasPrice, 
        setStatus
      },
        0,
        true,
        whiteListEnabled,
      ).then(newTokenId => {
        setMintingPreSale(false);
        console.log('minting complete');
        setTokenId(newTokenId);
      })
    });
  }

  const mintButton = (
    <Button className="button-minting" type="primary" disabled={!mintEnabled || minting} onClick={startMinting}>
      {minting ? <LoadingOutlined/> : "MINT 1 FOR " + priceDisplayed + " FTM"}
    </Button>
  )
 
  const mintPreSaleButton = (
    <Button className="button-minting" type="primary" disabled={!mintPresaleEnabled || minting} onClick={startPresaleMinting}>
      {mintingPreSale ? <LoadingOutlined/> : whiteListDisplayed}
    </Button>
  )

  const minterSection = (
    <div style={{ margin: "auto" }}>
        {badConnection ? badConnectionText : mintedSoFarText}
        {(!badConnection && !mintRemaining) ? outOfNFTs : ""}
        <p className="content content-collection">
            {!whiteListEnabled && !mintEnabled && mintRemaining ? "Insufficient balance" : ""}
        </p>
        <p>
            {status}
        </p>
        <p className="content content-collection">
            {mintRemaining && !publicSaleEnabled && !freeMintOpened ? "Minting is not opened yet. " : ""}
            {mintRemaining && !publicSaleEnabled && freeMintOpened ? "Public sale is not opened yet. " : ""}
            {mintRemaining && !publicSaleEnabled && freeMintOpened && whiteListEnabled && (whiteListEnabled == 0)? "If your wallet still has free mint spots, your mint button will appear shortly" : ""}
        </p>
        <div>
          {mintRemaining && publicSaleEnabled ? mintButton : ""}
        </div>
        <div>
          {mintRemaining && whiteListEnabled && (whiteListEnabled > 0) ? mintPreSaleButton : ""}
        </div>

    </div>
  );


  return minterSection;
}
